"use client";

import { Disclosure } from "@headlessui/react";
import { MinusSmallIcon, PlusSmallIcon } from "@heroicons/react/24/outline";

import { OverHeading } from "@/components/text/OverHeading";
import { SmallPreamble } from "@/components/text/SmallPreamble";

export function FaqItem({
  question,
  children,
}: {
  question: string;
  children: React.ReactNode;
}) {
  return (
    <Disclosure as="div" className="pt-6">
      {({ open }) => (
        <>
          <dt>
            <Disclosure.Button className="flex w-full items-start justify-between text-left text-gray-900">
              <OverHeading elementType="span" className="text-gray-900">
                {question}
              </OverHeading>
              <span className="ml-6 flex h-7 items-center">
                {open ?
                  <MinusSmallIcon className="h-6 w-6" aria-hidden="true" />
                : <PlusSmallIcon className="h-6 w-6" aria-hidden="true" />}
              </span>
            </Disclosure.Button>
          </dt>
          <Disclosure.Panel as="dd" className="mt-2 pr-12">
            <SmallPreamble
              elementType="p"
              className="text-base leading-7 text-gray-600"
            >
              {children}
            </SmallPreamble>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}
